import * as fornecedor from '@/api/fornecedor'
import { convertSelect } from '../../../service/collection'

const state = {
  pacotes: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAddPacote: false,
  modalConfirma: false
}

const mutations = {
  SETPACOTES (state, payload) {
    state.pacotes = payload
  },
  SETFORNECEDORESSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  HIDDEMODAL (state) {
    state.modalAddPacote = false
    state.modalConfirma = false
  },
  MODALADDPACOTE (state) {
    state.modalAddPacote = !state.modalAddPacote
  },
  MODALCONFIRMA (state) {
    state.modalConfirma = !state.modalConfirma
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAddPacote: function ({ commit }) {
    commit('MODALADDPACOTE')
  },
  modalConfirma: function ({ commit }) {
    commit('MODALCONFIRMA')
  },
  async addPacote ({ commit }, payload) {
    try {
      payload.fornecedor.id = payload.fornecedor.value
      for (let p = 0; p < payload.tipos.length; p++) {
        payload.tipos[p].id = payload.tipos[p].value
      }
      let retorno = await fornecedor.addPacote(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async getPacotes ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await fornecedor.pacotes(payload)
    commit('SETPACOTES', data)
    commit('SETPAGINATE', data.pages)
  },
  async getPacotesFiltro ({ commit, dispatch }) {
    let data = await fornecedor.pacotes(state.filtros)
    commit('SETPACOTES', data)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETPACOTES', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getFornecedoresSelect ({ commit }, payload) {
    let data = await fornecedor.fornecedoresSelect()
    commit('SETFORNECEDORESSELECT', data)
  },
  async inativaPacote ({ commit }, payload) {
    try {
      await fornecedor.inativaPacote(payload)
      return true
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getPacotes', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/fornecedor.js